import AdminConnectedContainer from "components/container/AdminConnectedContainer.tsx";
import {useTranslation} from "react-i18next";

function AdminDashboardPage() {
    const{t} = useTranslation()


    return (
        <AdminConnectedContainer title={t('menu.admin.dashboard')}>
            <h1>
                En cours
            </h1>
        </AdminConnectedContainer>
    )
}

export default AdminDashboardPage
